var map = {
	"./20110515_1.jpg": 13201,
	"./20110515_2.jpg": 71782,
	"./20110515_3.jpg": 36483,
	"./20110515_4.jpg": 21680,
	"./20110515_5.jpg": 48781,
	"./20110515_6.jpg": 16642,
	"./20110515_7.jpg": 36639,
	"./20110515_8.jpg": 8892
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83561;